import naja from 'naja';
import onDomReady from './onDomReady';
import Filters from './components/filters';
import MapController from './components/mapController';

class Paginator {
	constructor(button, resultsEl, url, page, urlFiltersCount) {
		onDomReady(() => {
			this.button = button;
			this.resultsEl = resultsEl;
			this.url = url;
			this.page = page;
			this.isNextPage = false;
			this.firstLoad = true;
			this.map = new MapController();
			this.urlFiltersCount = urlFiltersCount;

			// Událost kliknutí na tlačítko
			button.addEventListener('click', () => {
				if (this.isNextPage) {
					this.page++;
					this.loadData();
				}
			});

			// Posluchač události změny filtru
			window.addEventListener('filter:changed', e => {
				this.page = 1;
				this.isNextPage = false;
				this.loadData(true);
			});

			this.defaultText = button.getAttribute('data-text');
			this.loadingText = button.getAttribute('data-text-loading');
			this.filterManager = new Filters(this.urlFiltersCount);

			this.loadData();
		});
	}

	// Skryje tlačítko
	hideButton() {
		this.button.style.display = 'none';
	}

	// Zobrazí tlačítko
	showButton() {
		this.button.style.display = 'inline-block';
	}

	// Spustí animaci načítání
	loadingStarted() {
		this.button.textContent = this.loadingText;
		this.button.setAttribute('disabled', 'true');
	}

	// Ukončí animaci načítání
	loadingEnded() {
		this.button.textContent = this.defaultText;
		this.button.removeAttribute('disabled');
	}

	// Načte data
	loadData(clear = false) {
		this.loadingStarted();

		this.filterManager
			.dataForQuery()
			.then(data => {
				data.page = this.page;
				if (this.firstLoad) {
					data.fl = true;
					this.firstLoad = false;
				}

				return naja.makeRequest('GET', this.url, data, {
					history: false,
				});
			})
			.then(r => {
				this.loadingEnded();
				this.isNextPage = r.isNextPage;

				// Writing the results
				if (clear) {
					this.resultsEl.innerHTML = r.html;
				} else {
					this.resultsEl.insertAdjacentHTML('beforeend', r.html);
				}
				window.LazyLoad.update();

				// Button check
				if (r.isNextPage) {
					this.showButton();
				} else {
					this.hideButton();
				}

				// Updating filters
				this.filterManager.fromServerResponse(r.filters);
				this.filterManager.setFiltersCount(r.filtersCount);

				// Url update
				if (r.fragment) {
					window.location.hash = r.fragment;
				} else {
					let hi = window.location.href.indexOf('#');
					if (hi > 0) {
						window.history.pushState(
							{},
							'',
							window.location.href.substring(0, hi),
						);
					}
				}

				const loc = new URL(window.location.href);
				if (this.page === 1) {
					loc.searchParams.delete('page');
				} else {
					loc.searchParams.set('page', this.page);
				}

				this.map.addMarkers(r.markers);

				window.history.pushState({}, '', loc.toString());
			})
			.catch(() => {
				this.loadingEnded();
			});
	}
}

// Získání elementů
const settingsEl = document.querySelector('#paginator-settings');
const resultsEl = document.querySelector('#paginator-results');
const resultsButton = document.querySelector('#paginator-button');

if (settingsEl && resultsEl && resultsButton) {
	const settingsJson = settingsEl.textContent.trim();
	const settings = JSON.parse(settingsJson);
	new Paginator(
		resultsButton,
		resultsEl,
		settings.loadMoreUrl,
		settings.page || 1,
		settings.updateFiltersUrl,
	);
}
